<template>
  <div>
    <b-modal v-model="isModalActive" :title="selectedId ? 'แก้ไขการแจ้งเตือน' : 'เพิ่มการแจ้งเตือน'" hide-footer>
      <b-overlay :show="isFetching || isLoading">
        <ValidationObserver ref="notificationForm" v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(onSubmit)">
              <AgentsSelectInput
                :value="form.agentId"
                label-cols="3"
                @update="(agentId) => form.agentId = agentId"
              />
            <b-form-group
              label="เลือกประเภท"
              label-cols-lg="3"
              label-cols-sm="12"
              label-for="type"
            >
              <b-select id="type" v-model="form.type">
                <b-form-select-option
                  v-for="(type, typeI) in typeOptions"
                  :key="typeI"
                  :value="type.value"
                  >{{ type.name }}
                </b-form-select-option>
              </b-select>
            </b-form-group>
            <b-form-group
                label="แอพพลิเคชั่น"
                label-cols-lg="3"
                label-cols-sm="12"
                label-for="application"
            >
              <b-select id="application" v-model="form.application">
                <b-form-select-option
                    v-for="(app, i) in appOptions"
                    :key="i"
                    :value="app.value"
                >{{ app.name }}
                </b-form-select-option>
              </b-select>
            </b-form-group>
            <b-form-group
              label="ชื่อ"
              label-cols-lg="3"
              label-cols-sm="12"
              label-for="name"
            >
              <b-input id="name" v-model="form.name"> </b-input>
            </b-form-group>
            <b-form-group
              label="Chat ID"
              label-cols-lg="3"
              label-cols-sm="12"
              label-for="chatId"
            >
              <b-input id="chatId" v-model="form.chatId"> </b-input>
            </b-form-group>

            <div class="text-right">
              <b-button class="mr-2" variant="light" @click="closeModal">
                {{ $t('buttons.cancel') }}
              </b-button>
              <b-overlay
                :show="isLoading"
                class="d-inline-block"
                rounded
                spinner-small
              >
                <b-button block type="submit" variant="primary">
                  {{ $t('buttons.confirm') }}
                </b-button>
              </b-overlay>
            </div>
          </form>
        </ValidationObserver>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'

export default {
  name: 'NotificationForm',
  components: {
    AgentsSelectInput: () => import('@components/agents/agents-select-input'),
  },
  data() {
    return {
      selectedId: null,
      isModalActive: false,
      typeOptions: [
        { value: 'deposit', name: 'ฝาก'},
        { value: 'withdraw', name: 'ถอน'},
        { value: 'withdraw-otp', name: 'OTP ถอน'},
        { value: 'emergency', name: 'Emergency'},
        { value: 'update-user', name: 'แก้ไขข้อมูลยูสเซอร์'},
        { value: 'adjust-balance', name: 'โยกเงินอัตโนมัติ'}
      ],
      appOptions: [
        { value: 'telegram', name: 'Telegram' },
        { value: 'line', name: 'Line' },
      ],
      form: {
        agentId: '',
        application: '',
        type: '',
        name: '',
        chatId: '',
      },
    }
  },
  computed: {
    ...mapState({
      isFetching: (state) => state.notification.isFetchingNotification,
      isLoading: (state) => state.notification.isCreatingNotification || state.notification.isUpdatingNotification,
      detail: (state) => state.notification.notificationDetail,
    }),
  },
  watch: {
    selectedId(val) {
      if (val) {
        this.fetchData()
      }
    },
    detail(val){
      if (val){
        this.setData()
      }
    },
  },
  created() {
    this.resetForm()
  },
  methods: {
    ...mapActions(['createNotification', 'fetchNotificationById', 'updateNotification']),
    fetchData() {
      if (this.selectedId) {
        this.fetchNotificationById(this.selectedId)
      }
    },
    setData() {
      if (this.detail && this.detail.id) {
        const data = JSON.parse(JSON.stringify(this.detail))
        this.form = {
          id: data.id,
          agentId: data.agentId || '',
          application: data.application || '',
          type: data.type || '',
          name: data.name || '',
          chatId: data.chatId || '',
        }
      } else {
        this.resetForm()
      }
    },
    showModal(id) {
      this.selectedId = id
      this.isModalActive = true
    },
    closeModal() {
      this.isModalActive = false
      this.selectedId = null
      this.resetForm()
    },
    resetForm() {
      this.form = {
        agentId: '',
        application: '',
        type: '',
        name: '',
        chatId: '',
      }
    },
    async onSubmit() {
      if (this.isLoading) return
      if (this.form.id){
        await this.updateNotification({id: this.form.id, data: this.form})
        this.closeModal()
      } else {
        await this.createNotification(this.form)
        this.closeModal()
      }
    },
  },
}
</script>
